"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _reduceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = mapDispatch;

function mapDispatch(funcs) {
  var _context;

  var store = this.store;
  return _reduceInstanceProperty(_context = _Object$keys(funcs)).call(_context, function (obj, name) {
    obj[name] = function () {
      var action = funcs[name].apply(funcs, arguments);
      action._id = _Symbol();
      return store.dispatch(action);
    };

    return obj;
  }, this);
}